<!--

# Represent checkboxes for each given accessible Group of a User.

This is meant to be a child of a v-list, since it renders v-list-tiles.
We can extend e.g. a v-menu with it to allow filtering based on
selected uploadgroups.

## Vuex Integration

By passing a list of candidate groups, an extra list to remember the
selected ids in the store and reacting to the @change event we can make
this fully work with a vuex store.

-->

<template>
  <div>
    <v-divider />
    <v-subheader>{{ $t('groupsFilterLabel') }}</v-subheader>
    <v-list-tile
      :disabled="disabled"
      class="list-tile-auto-height"
    >
      <v-layout column>
        <v-checkbox
          v-for="group in orderedGroups"
          :key="group.id"
          class="menu-max-width mt-1"
          color="msr"
          hide-details
          :label="group.name"
          :input-value="groupIsSelected(group)"
          @change="onGroupToggled(group, $event)"
        />
      </v-layout>
    </v-list-tile>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
  props: {
    /* Group candidates to choose from. */
    groups: {
      type: Array[Object],
      required: true,
    },
    /* List of currently selected Group ids. Usually from a store. */
    selectedGroupIds: {
      type: Array[String | Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Return Groups ordered by name (case insensitive).
     */
    orderedGroups() {
      return orderBy(this.groups, [(group) => group.name.toLowerCase()]);
    },
  },
  methods: {
    groupIsSelected(group) {
      if (!this.selectedGroupIds) {
        return false;
      }
      return this.selectedGroupIds.indexOf(group.id) !== -1;
    },
    onGroupToggled(group, selected) {
      this.$emit('change', group, selected);
    },
  },
};
</script>

<style scoped>
/* While the v-menu should grow automatically, set a limit. */
.menu-max-width {
  max-width: 480px;
}
@media (max-width: 599px) {
  .menu-max-width {
    max-width: 240px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GroupFilterMenuItems.vue